/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MigratedQuestMilestone } from './MigratedQuestMilestone';
import {
    MigratedQuestMilestoneFromJSON,
    MigratedQuestMilestoneFromJSONTyped,
    MigratedQuestMilestoneToJSON,
    MigratedQuestMilestoneToJSONTyped,
} from './MigratedQuestMilestone';

/**
 * 
 * @export
 * @interface MigratedQuestSample
 */
export interface MigratedQuestSample {
    /**
     * 
     * @type {string}
     * @memberof MigratedQuestSample
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MigratedQuestSample
     */
    name: string;
    /**
     * 
     * @type {Array<MigratedQuestMilestone>}
     * @memberof MigratedQuestSample
     */
    milestones: Array<MigratedQuestMilestone>;
}

/**
 * Check if a given object implements the MigratedQuestSample interface.
 */
export function instanceOfMigratedQuestSample(value: object): value is MigratedQuestSample {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('milestones' in value) || value['milestones'] === undefined) return false;
    return true;
}

export function MigratedQuestSampleFromJSON(json: any): MigratedQuestSample {
    return MigratedQuestSampleFromJSONTyped(json, false);
}

export function MigratedQuestSampleFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigratedQuestSample {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'milestones': ((json['milestones'] as Array<any>).map(MigratedQuestMilestoneFromJSON)),
    };
}

export function MigratedQuestSampleToJSON(json: any): MigratedQuestSample {
    return MigratedQuestSampleToJSONTyped(json, false);
}

export function MigratedQuestSampleToJSONTyped(value?: MigratedQuestSample | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'milestones': ((value['milestones'] as Array<any>).map(MigratedQuestMilestoneToJSON)),
    };
}

